import { useContext, useEffect, useState } from "react"
import { AppContext } from "./context"
import moment from "moment-timezone"
import { apiUrl } from "./delcare"
import { useAuth0 } from "@auth0/auth0-react"
import KioskActive from "./kiosk_active"
import KioskProcess from "./kiosk_process"

// moment.tz.setDefault("UTC")

let defaultQuery = 'query MyQuery {analytics_economics_2024_03_15 {economics(marketplaceIds:"ATVPDKIKX0DER",startDate:"2025-09-01",endDate:"2025-09-30",includeComponentsForFeeTypes:[FBA_FULFILLMENT_FEE,FBA_STORAGE_FEE],aggregateBy:{date:MONTH}) {cost {costOfGoodsSold {amount currencyCode} fbaCost {shippingToAmazonCost {amount currencyCode}} mfnCost {fulfillmentCost {amount currencyCode} storageCost {amount currencyCode}} miscellaneousCost {amount}} ads {adTypeName charge {amount {amount currencyCode} amountPerUnit {currencyCode amount} amountPerUnitDelta {amount currencyCode} promotionAmount {amount currencyCode} quantity taxAmount {amount currencyCode} totalAmount {amount currencyCode}}} endDate fees {charge {aggregatedDetail {amount {amount} amountPerUnit {amount} amountPerUnitDelta {amount} promotionAmount {amount} quantity taxAmount {amount} totalAmount {amount}} properties {propertyName propertyValue} components {aggregatedDetail {amount {amount} amountPerUnit {amount} amountPerUnitDelta {amount} promotionAmount {amount} taxAmount {amount} totalAmount {amount} quantity} properties {propertyName propertyValue} name} identifier} charges {aggregatedDetail {amount {amount} amountPerUnit {amount} amountPerUnitDelta {amount} promotionAmount {amount} taxAmount {amount} totalAmount {amount} quantity} components {aggregatedDetail {amount {amount} amountPerUnit {amount} amountPerUnitDelta {amount} promotionAmount {amount} taxAmount {amount} totalAmount {amount} quantity} properties {propertyName} name} properties {propertyName propertyValue} identifier} feeTypeName} netProceeds {perUnit {amount} total {amount}} sales {averageSellingPrice {amount} orderedProductSales {amount} refundedProductSales {amount} unitsOrdered unitsRefunded netProductSales {amount} netUnitsSold} marketplaceId startDate}}}'


const Kiosk = () => {

    let { isAuthenticated, isLoading } = useAuth0()

    let { marketplaceList, neonUser, getMarketPlace, fetchData, kioskEnable, token } = useContext(AppContext)

    let [clientList, setClientList] = useState([])
    let [selectedClientList, setSelectedClientList] = useState([])
    let [selectedMarketplace, setSelectedMarketplace] = useState(null)

    let [dateMin, setDateMin] = useState("")
    let [dateMax, setDateMax] = useState("")
    let [showConfig, setShowConfig] = useState(true)
    let [searchClientId, setSearchClientId] = useState("")
    let [urlList, setUrlList] = useState([])
    let [kioskQuery, setKioskQuery] = useState("")
    let [error, setError] = useState("")
    let [message, setMessage] = useState("")
    let [loading, setLoading] = useState(false)
    let [kioskDataList, setKioskDataList] = useState([])
    let [refreshTime, setRefreshTime] = useState(null)
    let [disableRefresh, setDisableRefresh] = useState(false)
    let [disabledButton, setDisabledButton] = useState([])


    let getAllClient = async () => {
        return false
        let sql = `
        SELECT DISTINCT ON (client_info_id) * FROM bispoke_neon_db_enhancement ORDER BY client_info_id ASC
        `
        try {
            let resp = await fetchData(sql, "/neon-query")
            console.log("GET ALL CLIEN ID", resp)

            // resp = resp.filter((obj, index, self) =>
            //     index === self.findIndex((t) => t.client_id == obj.client_id)
            // );
            let resp2 = []
            if (resp.length > 0) {
                let sql2 = `SELECT * FROM client_authorisations WHERE client_id IN (${resp.map(x => x.client_info_id).filter(x => !!x).join(",")}) AND active = TRUE`

                resp2 = await fetchData(sql2, "/neon-market")

                // console.log("AUTHORISATION LIST", resp2, sql2)

                let list = resp2.map(x => { return { ...x, info: resp.filter(xx => xx.client_info_id == x.client_id)[0] || null } })

                console.log("CLIENT LIST", list)
                setClientList(list)


            }

            // setClientList(resp.map( x => { return {...x, client_id: x.client_info_id}}))
        }
        catch (err) {
            console.log("ERROR GET ALL CLIENT DATA", err)
            return
        }

    }

    let addClientList = (x) => {
        return false
        console.log("ADD CLIENT LIST", x)
        setSearchClientId("")
        if (selectedClientList.filter(xx => xx.client_id == x.client_id).length > 0) return;

        console.log(x)
        setSelectedClientList([...selectedClientList, x])
    }

    const fetchHander = async (client) => {
        return false
        // let formatQuery = kioskQuery.replaceAll('"', '\"')
        let formatQuery = kioskQuery
        //  setKioskQuery(formatQuery)

        // console.log({formatQuery})
        // return


        // let marketplaceId = formatQuery.match(/marketplaceIds:\"(.*?)(\")/g) || formatQuery.match(/marketplaceId:\"(.*?)(\")/g)
        // let startDate = formatQuery.match(/startDate:\"(.*?)(\")/g)
        // let endDate = formatQuery.match(/endDate:\"(.*?)(\")/g)


        let marketplaceId = selectedMarketplace.marketplaceid
        let startDate = dateMin
        let endDate = dateMax

        // console.log({marketplaceId, startDate, endDate})
        // return

        // try {
        //     marketplaceId = marketplaceId[0].match(/\"(.*?)\"/g)[0].replaceAll('"', '');
        //     startDate = startDate[0].match(/\"(.*?)\"/g)[0].replaceAll('"', '')
        //     endDate = endDate[0].match(/\"(.*?)\"/g)[0].replaceAll('"', '')


        // }
        // catch (err) {
        //     console.log("SOMETHING IS WRONG WITH THE QUERY", err)
        //     setError("Something is wrong with the query provided.")
        //     return
        // }
        let country = marketplaceList.filter(x => x.marketplaceid == marketplaceId)[0].countrycode
        let body = {
            "client_id": client.client_id,
            "start_date": startDate,
            "end_date": endDate,
            "countrycode": country,
            "refresh_token": client.refresh_token,
            "kiosk_query": formatQuery
        };
        console.log({ body: body.kiosk_query })
        // return
        await fetch(apiUrl + "/amazon_kiosk", {
            method: "POST",
            headers: (() => {
                const myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");


                myHeaders.append("Authorization", `Bearer ${token.accessToken}`)




                return myHeaders
            })(),
            body: JSON.stringify(body)
        })
            .then(resp => {

                if (!resp.ok) {

                    console.log("ERROR IN FETCH HANLDER", resp)
                    // setError("ERROR")

                    // setKioskDataList(old => [...old, {...client, error: "ERROR", expire: moment.tz("UTC").add(5, 'minutes')}])
                    // return
                }
                return resp.json()

            })
            .then(resp => {
                console.log("FETCH HANDLER ", resp)

                if ("error" in resp) setKioskDataList(old => [...old, { ...client, error: resp.error, expire: moment.tz("UTC").add(5, 'minutes') }])
                // return
                setMessage("Request Submitted")

            }).catch(err => {
                console.log("ERROR IN FETCH HANLDER 2", err)
            })
        return true
    }

    const retryHandler = async (x) => {
        return false
        setLoading(true)
        console.log({ retry: x, list: urlList.filter(xx => xx.client_id != x.client_id) })
        setUrlList(urlList.filter(xx => xx.client_id != x.client_id))
        await fetchHander(x)
        setLoading(false)
        return
    }

    const submitHandler = async () => {
        return false
        setUrlList([])
        setError("")
        setMessage("")


        if (selectedClientList.length == 0) {
            setError("no client id selected")
            return
        }
        if (!selectedMarketplace) {
            setError("no marketplace selected")
            return
        }

        if (!dateMax) {
            setError("no start date selected")
            return
        }

        if (!dateMin) {
            setError("no end date selected")
            return
        }

        if (!kioskQuery) {
            setError("no query provided")
            return
        }



        // let tokenList = selectedClientList.map(x => x.refresh_token)
        // console.log(selectedClientList.map( x => x.refresh_token))
        // let resultUrl = []
        setLoading(true)
        for (let i = 0; i < selectedClientList.length; i++) {

            await new Promise(resolve => {
                setTimeout(() => {
                    fetchHander(selectedClientList[i])
                    resolve()
                }, 200)
            })

        }
        setLoading(false)

        setShowConfig(true)
        return
    }

    const uploadHandler = async (client) => {

        return false

        if (moment.tz(client.expire, "UTC").isBefore(moment.tz("UTC"))) {
            setError("URL link expired")
            await getKioskData()
            return
        }
        // console.log(client)
        // return
        // let formatQuery = kioskQuery.replaceAll("\"", "\\\"")

        // let marketplaceId = formatQuery.match(/marketplaceIds:\\"(.*?)(\\")/g)
        // let startDate = formatQuery.match(/startDate:\\"(.*?)(\\")/g)
        // let endDate = formatQuery.match(/endDate:\\"(.*?)(\\")/g)
        let url = client.document_url
        let country = client.countrycode
        let client_id = client.client_id
        let startDate = moment(client.start_date).format("YYYYMMDD")
        let endDate = moment(client.end_date).format("YYYYMMDD")



        // if (marketplaceId.length > 0) {
        //     marketplaceId = marketplaceId[0].match(/\\"(.*?)\\"/g)[0].replaceAll("\\\"", "")
        // }
        // let country = marketplaceList.filter(x => x.marketplaceid == marketplaceId)
        // if (country.length > 0) country = country[0].countrycode

        // if (startDate.length > 0) {
        //     startDate = startDate[0].match(/\\"(.*?)\\"/g)[0].replaceAll("\\\"", "")
        //     startDate = moment(startDate).format("YYYYMMDD")
        // }
        // if (endDate.length > 0) {
        //     endDate = endDate[0].match(/\\"(.*?)\\"/g)[0].replaceAll("\\\"", "")
        //     endDate = moment(endDate).format("YYYYMMDD")
        // }


        let params = { startDate, endDate, country, url, client_id }
        // console.log(params)
        // return 

        setLoading(true)
        try {
            let upload_url = apiUrl + "/amazon_upload?"
            console.log({ upload_url })
            let resp = await fetch(upload_url, {
                method: "POST",
                headers: (() => {
                    const myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");



                    myHeaders.append("Authorization", `Bearer ${token.accessToken}`)


                    return myHeaders
                })(),
                body: JSON.stringify(params)
            })
            resp = await resp.json()
            console.log("UPLOAD HANDLER", resp)
            if ("json" in resp) {
                const blob = new Blob([resp.json], { type: 'text/plain' });
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
            }

            setMessage("Saved to Big Query And AWS S3")
            setLoading(false)
            return
        }
        catch (err) {
            setLoading(false)
            console.log("KIOSK ERROR IN UPLOAD TO S3", err)
            setError("KIOSK ERROR IN UPLOAD TO S3")
            return
        }

    }

    const getKioskData = async () => {
        return false

        let sql = `select * from kiosk_data where document_url is not null `

        let resp = await fetchData(sql, "/neon-query")

        console.log("GET KIOSK DATA", resp)

        setKioskDataList(resp)

        return
    }

    const refreshList = async () => {
        return false
        setDisableRefresh(true)
        setRefreshTime(null)
        setError("")
        setMessage("")

        const highestId = window.setTimeout(() => {
            for (let i = highestId; i >= 0; i--) {
                console.log("CLEAR ALL TIMEOUT", i)
                window.clearInterval(i);
            }
        }, 100);



        await getKioskData()
        setRefreshTime(moment.tz("UTC"))
        setTimeout(() => {
            setDisableRefresh(false)
        }, 10000)

        return
    }

    let marketpaceChangeHandler = (x) => {
        return false

        let new_query = kioskQuery.replaceAll(/marketplaceId(.*?)"(.*?)"/g, `marketplaceIds:\"${x.marketplaceid}\"`)

        setKioskQuery(new_query)

        setSelectedMarketplace(x)

    }

    let dateChangeHandler = (x, type) => {

        return false

        if (type == 'start') {
            let new_query = kioskQuery.replaceAll(/startDate(.*?)"(.*?)"/g, `startDate:\"${x}\"`)

            setKioskQuery(new_query)

            setDateMin(x)
        }

        if (type == 'end') {
            let new_query = kioskQuery.replaceAll(/endDate(.*?)"(.*?)"/g, `endDate:\"${x}\"`)

            setKioskQuery(new_query)

            setDateMax(x)
        }

    }

    useEffect(() => {
        console.log(urlList)
    }, [urlList])


    useEffect(() => {

        if ("user" in neonUser && neonUser.user.user_id) {

            if (marketplaceList.length == 0) getMarketPlace();

            if (clientList.length == 0) getAllClient()
        }

    }, [neonUser])

    useEffect(() => {
        console.log("KIOSK", { marketplaceList })
    }, [marketplaceList])



    useEffect(() => {
        console.log("KIOSK", { selectedClientList })

    }, [selectedClientList])


    useEffect(() => {
        console.log("KIOSK", { selectedMarketplace })
    }, [selectedMarketplace])

    useEffect(() => {
        // if (moment(dateMax).isBefore(moment(dateMin))) {
        //     console.log("MAX DATE IS BEFORE MIN DATE")
        //     setDateMin(moment(dateMax).subtract(1, "days").format("YYYY-MM-DD"))
        // }

    }, [dateMax])
    useEffect(() => {

        // if (moment(dateMin).isAfter(moment(dateMax))) {
        //     console.log("MIN DATE IS AFTER MAX DATE")
        //     setDateMax(moment(dateMax).add(1, "days").format("YYYY-MM-DD"))
        // }
    }, [dateMin])

    useEffect(() => {
        console.log("KIOSK", { isAuthenticated, isLoading })
    }, [isAuthenticated, isLoading])


    useEffect(() => {
        console.log("KIOSK ENABLE", kioskEnable)
    }, [kioskEnable])

    useEffect(() => {
        // setKioskQuery(kioskQuery.replaceAll("\"", "\\\""))
        if (!neonUser || !kioskQuery || marketplaceList.length == 0) return;
        let marketplace = kioskQuery.match(/marketplaceId(.*?)"(.*?)"/g)
        let startDate = kioskQuery.match(/startDate(.*?)"(.*?)"/g)
        let endDate = kioskQuery.match(/endDate(.*?)"(.*?)"/g)

        console.log("KIOSK QUERY ", { marketplace, startDate, endDate })

        if (!!marketplace) {
            // console.log(marketplace[0].match(/"(.*?)"/g)[0].replaceAll("\"",""))
            marketplace = marketplace[0].match(/"(.*?)"/g)[0].replaceAll("\"", "")
            setSelectedMarketplace(marketplaceList.filter(x => x.marketplaceid == marketplace)[0])
            setDisabledButton(old => old.filter(x => x != 'marketplace'))
        }
        else {
            let disabled = [...disabledButton]
            disabled.push('marketplace')
            setDisabledButton(disabled)
            setSelectedMarketplace(null)
        }

        if (!!startDate) {
            startDate = startDate[0].match(/"(.*?)"/g)[0].replaceAll("\"", "")
            console.log({ startDate })
            setDateMin(startDate)
            setDisabledButton(old => old.filter(x => x != 'startdate'))
        }
        else {


            setDisabledButton(old => [...old, 'startdate'])
            setDateMin("")


        }
        if (!!endDate) {
            endDate = endDate[0].match(/"(.*?)"/g)[0].replaceAll("\"", "")
            console.log({ endDate })
            setDateMax(endDate)
            setDisabledButton(old => old.filter(x => x != 'enddate'))
        }
        else {


            setDisabledButton(old => [...old, 'enddate'])
            setDateMax("")
        }

    }, [kioskQuery, neonUser, marketplaceList])



    useEffect(() => {
        console.log("DISABLED BUTTON", disabledButton)
    }, [disabledButton])

    useEffect(() => {

        (async () => {
            if (!("user_id" in neonUser)) return

            await getKioskData()
            return

        })()

    }, [neonUser])



    useEffect(() => {
        setKioskQuery(defaultQuery)
    }, [])

    return (
        <>not in service</>
    )

    return (
        <div className="container-fluid py-2" >
            {kioskEnable ?


                <div className="d-flex flex-column gap-2 poppins">
                    <div className="d-flex flex-column gap-1">
                        <div className="d-flex gap-1 ">

                            <div className="dropdown">
                                <button disabled={clientList.length == 0 || clientList.length == selectedClientList.length} className="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    -Select Client ID-
                                </button>
                                <div className="dropdown-menu" >
                                    <div className="px-1 mb-1">
                                        <input type="text" className="form-control form-control-sm" placeholder="client id" onChange={e => setSearchClientId(e.target.value)} />
                                    </div>
                                    <div style={{ maxHeight: 400, overflowY: "scroll" }}>
                                        {/* <li><a className="dropdown-item" href="#">Action</a></li> */}
                                        {clientList.filter(x => !selectedClientList.map(xx => xx.client_id).includes(x.client_id) && x.client_id.includes(searchClientId)).map((x, i) => (
                                            <div key={x.client_id} className="dropdown-item text-center" onClick={() => addClientList(x)}>{x.client_id} ({x.info.seller_id})</div>
                                        ))
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="dropdown" >
                                <button disabled={disabledButton.includes('marketplace')} className="btn btn-primary dropdown-toggle " type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    {selectedMarketplace ? selectedMarketplace.country : disabledButton.includes('marketplace') ? "no marketplace key in query" : "-Select Marketplace-"}
                                </button>
                                <ul className="dropdown-menu" style={{ maxHeight: 400, overflowY: "scroll" }}>

                                    {marketplaceList.map((x, i) => (
                                        <li key={x.marketplaceid} className="dropdown-item " onClick={() => marketpaceChangeHandler(x)}>{x.country}</li>
                                    ))
                                    }
                                </ul>
                            </div>



                            <div className="d-block">
                                <div className="input-group  mb-0">
                                    <span className="input-group-text bg-primary text-white" id="inputGroup-sizing-default">Start Date</span>
                                    {!disabledButton.includes('startdate')
                                        ?
                                        <input type="date" className="form-control" value={dateMin} onChange={(e) => dateChangeHandler(e.target.value, 'start')} max={moment().subtract(1, 'days').format("YYYY-MM-DD")} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />
                                        :
                                        <input type="text" disabled value="no startDate key in query" />

                                    }
                                </div>
                            </div>

                            <div className="d-block">
                                <div className="input-group  mb-0 ">
                                    <span className="input-group-text bg-primary text-white" id="inputGroup-sizing-default">End Date</span>
                                    {!disabledButton.includes('enddate') ?
                                        <input type="date" className="form-control " value={dateMax} onChange={(e) => dateChangeHandler(e.target.value, 'end')} max={moment().format("YYYY-MM-DD")} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" />

                                        :
                                        <input type="text" disabled value="no endDate key in query" />
                                    }

                                </div>

                            </div>

                        </div>
                        <div>
                            <button disabled={clientList.length == 0} type="button" className="btn btn-light  btn-sm my-0" onClick={() => setSelectedClientList(clientList)}>Select All</button>

                            <button type="button" className="btn btn-light  btn-sm my-0" onClick={() => setSelectedClientList([])}>Clear All</button>

                        </div>

                    </div>



                    <div className="d-flex gap-1 w-100 flex-wrap">
                        {selectedClientList.map((x, i) => (
                            <div key={x.client_id} className="badge  text-bg-info d-flex gap-2 " >
                                <span className="h6 mb-0" >{x.client_id}</span>
                                <span className="btn-close text-light align-self-center" aria-label="close" onClick={() => setSelectedClientList(selectedClientList.filter(xx => xx.client_id != x.client_id))}></span>
                            </div>

                        ))}
                    </div>
                    <div className="mb-3 w-100">
                        <label htmlFor="kiosk_query" className="form-label">Kiosk Query</label>
                        <textarea className="form-control" id="kiosk_query" rows="8" value={kioskQuery} onChange={e => setKioskQuery(e.target.value)}></textarea>
                    </div>
                    {error &&
                        <div className="alert alert-danger d-flex justify-content-between">
                            <span>{error}</span>
                            <span className="btn-close" aria-label="close" onClick={() => setError("")}></span>
                        </div>
                    }
                    {message &&
                        <div className="alert alert-success d-flex justify-content-between">
                            <span>{message}</span>
                            <span className="btn-close" aria-label="close" onClick={() => setMessage("")}></span>
                        </div>
                    }

                    <div className="d-flex gap-2 mb-2">
                        <button disabled={clientList.length == 0 || loading} onClick={submitHandler} className="btn btn-success btn-lg">Submit</button>
                        {/* <button disabled={clientList.length == 0 || loading || disableRefresh} onClick={refreshList} className="btn btn-info btn-sm">Refresh List</button> */}

                    </div>




                    <div className="">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className="nav-link active fw-bold" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">Active</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className="nav-link fw-bold" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Queued</button>
                            </li>
                        </ul>

                        <div className="tab-content bg-white " id="myTabContent">

                            <div className="tab-pane show active p-2" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabIndex="0">

                                <div className="d-flex gap-2 mb-2">

                                    {/* <button disabled={clientList.length == 0 || loading} onClick={submitHandler} className="btn btn-success btn-sm">Submit</button> */}
                                    <button disabled={clientList.length == 0 || loading || disableRefresh} onClick={refreshList} className="btn btn-info btn-sm">Refresh List</button>

                                </div>
                                {!!refreshTime && <small>Last refresh: {refreshTime.format("hh:mm:ss A")} UTC</small>}
                                <KioskActive kioskDataList={kioskDataList} loading={loading} uploadHandler={uploadHandler} />

                            </div>
                            <div className="tab-pane p-2" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabIndex="0">
                                <KioskProcess />

                            </div>
                        </div>
                    </div>



                </div >
                :
                kioskEnable == false ?
                    <div className="alert alert-danger">
                        <p className="poppins mb-0">Login to use this function. <a href={window.location.origin}>login</a></p>
                    </div>
                    :
                    <span className="poppins">loading...</span>


            }
        </div>

    )

}

export default Kiosk